import React from "react";
import styles from "./index.module.scss";
import Wait from "../../../../src/shared/assets/icons/waiting.svg";

export const OverlayLoader = () => {
  return (
    <div className={styles.overlay}>
      <img
        src={Wait}
        className={`${styles.img} ${styles.img__rotate}`}
        alt="Ваш счет формируется"
      />
    </div>
  );
};
